import { render, staticRenderFns } from "./addPrinterMachine.vue?vue&type=template&id=5061feb2"
import script from "./addPrinterMachine.vue?vue&type=script&lang=js"
export * from "./addPrinterMachine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports